import React from "react"
import classnames from "classnames"
import {
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  YoutubeIcon,
  A
} from "AtomicComponents"
import gtmHandler from "AtomicUtils/gtmHandler"

import styles from "./SocialIcons.less"
class SocialIcons extends React.PureComponent {

  _handleOnClick = (platform) => {
    const { gtm } = this.props

    // Delay for firing GTM before redirection
    // Call GTM with the gtm object or default to Footer
    gtmHandler({
      pageCategory: gtm && gtm.category ? gtm.category : "Footer Nav",
      pageAction: gtm && gtm.action ? gtm.action : `Footer - Clicked "${platform.toUpperCase()}"`
    })
  }

  render() {
    const { platforms = [] } = this.props
    return (
      <div className={classnames({
        [styles.SocialIcons]: true
      })}>
        <ul>
          {platforms.map( platform =>
            {
              let Icon = null
              if (platform.name === 'facebook') Icon = FacebookIcon
              if (platform.name === 'instagram') Icon = InstagramIcon
              if (platform.name === 'twitter') Icon = TwitterIcon
              if (platform.name === 'youtube') Icon = YoutubeIcon
              return (
                <li key={platform.name}>
                  <A
                    styleName='grey'
                    onClick={() => this._handleOnClick(platform.name)}
                    href={platform.href}
                    external
                  >
                    <Icon />
                  </A>
                </li>
              )
            }
          )}
        </ul>
      </div>
    )
  }
}


export default SocialIcons




// WEBPACK FOOTER //
// ./src/AtomicComponents/SocialIcons/SocialIcons.jsx